gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll('.stockists-grid__anchor').forEach(function (el) {
  var id = el.getAttribute('id');
  var title = el.getAttribute('data-title');
  var item = document.createElement('li');
  var link = document.createElement('a');
  var span = document.createElement('span');
  link.href = `#${id}`;
  span.innerText = title;
  link.appendChild(span);
  item.appendChild(link);
  document.querySelector('.stockists-section__menu ul').appendChild(item);
});

$('.faq-category__toggle').on('click', function () {
  var $target = $(this).closest('.faq-main');
  $('.faq-main.active').not($target).removeClass('active');
  $target.toggleClass('active');
});

$('.stockists-section__menu ul li:nth-child(1) a').addClass('active');

$('.stockists-section__menu ul li a').on('click', function () {
  var $target = $(this);
  $('.stockists-section__menu ul li a.active').not($target).removeClass('active');
  $(this).toggleClass('active');
});

ScrollTrigger.matchMedia({
  '(min-width: 992px)': function () {
    var offset = $('.header').height() + 20;
    // const offsetBottom = $('.faq-main__tab-links').height() + offset + 100;

    var ST = ScrollTrigger.create({
      trigger: '.stockists-section__col--sticky',
      endTrigger: '.stockists-banner-section',
      start: `${-offset} top`,
      end: 'top bottom',
      pin: true,
      pinSpacing: false,
    });
  },
});
